import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Mail, Inbox, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

const Stat = ({ label, value, icon: Icon, tid }) => (
    <div className="bg-white border border-gray-200 p-6 flex flex-col gap-4" data-testid={tid}>
        <div className="flex items-center justify-between">
            <div className="overline text-red-600">{label}</div>
            <Icon size={18} strokeWidth={1.5} className="text-gray-400" />
        </div>
        <div className="font-display text-4xl font-black tracking-tight">{value}</div>
    </div>
);

const AdminDashboard = () => {
    const [stats, setStats] = useState({ products: 0, inquiries: 0, new_inquiries: 0 });
    const [recent, setRecent] = useState([]);

    useEffect(() => {
        api.get("/stats").then(({ data }) => setStats(data)).catch(() => {});
        api.get("/inquiries").then(({ data }) => setRecent(data.slice(0, 5))).catch(() => {});
    }, []);

    return (
        <div data-testid="admin-dashboard">
            <div className="flex items-end justify-between mb-10">
                <div>
                    <div className="overline text-red-600 mb-3">Overview</div>
                    <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl">Dashboard</h1>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
                <Stat label="Products" value={stats.products} icon={Package} tid="stat-products" />
                <Stat label="Total Inquiries" value={stats.inquiries} icon={Mail} tid="stat-inquiries" />
                <Stat label="New Inquiries" value={stats.new_inquiries} icon={Inbox} tid="stat-new-inquiries" />
            </div>

            <div className="bg-white border border-gray-200">
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <div className="overline text-red-600">Recent Inquiries</div>
                    <Link to="/admin/inquiries" className="font-mono text-[11px] uppercase tracking-[0.18em] text-gray-700 inline-flex items-center gap-2 hover:text-red-600" data-testid="view-all-inquiries">
                        View All <ArrowUpRight size={14} />
                    </Link>
                </div>
                {recent.length === 0 ? (
                    <div className="p-10 text-sm text-gray-500">No inquiries yet.</div>
                ) : (
                    <ul>
                        {recent.map((inq) => (
                            <li key={inq.id} className="grid grid-cols-12 gap-4 p-6 border-b border-gray-100 items-center text-sm">
                                <div className="col-span-3 font-medium">{inq.name}</div>
                                <div className="col-span-3 text-gray-600">{inq.email}</div>
                                <div className="col-span-3 text-gray-600 truncate">{inq.machine_type || "—"}</div>
                                <div className="col-span-2 font-mono text-[11px] uppercase tracking-[0.16em] text-gray-500">{inq.status}</div>
                                <div className="col-span-1 text-right font-mono text-[10px] uppercase tracking-[0.18em] text-gray-400">
                                    {new Date(inq.created_at).toLocaleDateString()}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;
